import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'holidays',
    component: Children,

    children: [
      {
        path: '',
        component: Children,

        children: [
          {
            path: '',
            name: 'holidays',
            component: () => import('../pages/HolidaysPage.vue')
          }
        ]
      }
    ]
  }
];

export default routes;
